<template>
  <v-flex sm3 lg2 class="mr-2 accessibility-switch-container">
    <label for="accessible-view"
           v-if="this.isAccessible"
           class="menu--lang__label"
    >{{$t('accessible.accessibility_label')}}</label>
    <v-switch
      id="accessible-view"
      class="accessible-header"
      :class="[this.$store.state.profile.accessible ? accessColor : mainColor]"
      :aria-label="$t('aria_label_accessibility_toggle')"
      :label="this.isAccessible ? '' : $t('accessible.accessibility_label')"
      :color="color ? color : 'undefined'"
      role="switch"
      slot="activator"
      v-model="showAccessibleView"
      :aria-checked="showAccessibleView ? showAccessibleView : 'false'" />
    </v-flex>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import { UPDATE_STUDENT_ACCESSIBILITY } from '../../store/action-types'
import {IS_ACCESSIBLE} from '../../store/getter-types'

export default {
  name: 'accessibility-switch',
  props: ['color'],
  mixins: [],
  data () {
    return {
      mainColor: 'accessible-header__main',
      accessColor: 'accessible-header__access'
    }
  },
  computed: {
    ...mapState({
      loginStudentId: state => state.profile.studentId
    }),
    ...mapGetters({
      isAccessible: IS_ACCESSIBLE
    }),
    showAccessibleView: {
      get () {
        return this.$store.state.profile.accessible
      },
      set (value) {
        this.$store.dispatch(UPDATE_STUDENT_ACCESSIBILITY, {studentId: this.loginStudentId, active: value})
      }
    }
  }
}
</script>
<style scoped>
  .accessibility-switch-container {
    display: flex;
    align-items: center;
    gap: 0.75em;
  }

  .accessible-header.input-group.input-group--selection-controls {
    align-items: center;
  }

  .accessible-header.input-group.input-group--selection-controls >>> .input-group__details {
    display: none;
  }

  .accessible-header__access.input-group.input-group--selection-controls.switch >>> label {
    color: inherit;
  }

  .accessible-header__main.input-group.input-group--selection-controls.switch >>> label {
    color: #FFFFFF;
  }

</style>




// WEBPACK FOOTER //
// src/components/navbar/AccessibilitySwitch.vue